module.exports = __webpack_public_path__ + "static/img/logos_intro_DOAJC_montage.6f5dad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newlogos/logos_intro_DOAJC_montage.png
// module id = 1253
// module chunks = 1